import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Hero() {
  const goto = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" className="relative min-h-screen bg-paper overflow-hidden pt-32 pb-10 flex flex-col">
      {/* Top-right intro line */}
      <motion.p {...fade(0.05)}
        className="absolute top-32 right-6 max-w-[220px] text-right text-xs leading-relaxed text-ink-500 hidden lg:block">
        We partner with businesses from day one — from first model to full-scale deployment.
      </motion.p>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex-1 flex flex-col">
        <div className="grid lg:grid-cols-12 gap-8 flex-1 items-center">

          {/* Left yellow info card */}
          <motion.div {...fade(0.1)} className="lg:col-span-3">
            <div className="btn-lime rounded-2xl p-6 flex flex-col justify-between min-h-[260px]">
              <div>
                <h3 className="font-bold text-base mb-3 tracking-tight">TekJovi®</h3>
                <p className="text-xs leading-relaxed mb-4 text-ink/75">
                  We invest engineering, AI and cloud expertise into teams worth building for.
                </p>
                <p className="text-xs font-semibold leading-snug">
                  From kickoff to production in under 90 days.
                </p>
              </div>
              <button onClick={() => goto("#services")}
                className="flex items-center gap-1 text-xs font-semibold mt-6 hover:gap-2 transition-all duration-200">
                Details
                <ArrowUpRight size={13} />
              </button>
            </div>
          </motion.div>

          {/* Headline */}
          <div className="lg:col-span-9 relative">
            {/* Watermark word */}
            <div className="watermark hidden md:block text-[7.5rem] xl:text-[10rem] left-0 -bottom-2 select-none">
              TekJovi
            </div>

            <motion.h1 {...fade(0.18)}
              className="relative text-[2.6rem] sm:text-6xl md:text-7xl xl:text-[5.5rem] font-bold leading-[0.96] tracking-[-0.035em] text-ink">
              Engineering
              <br />
              bold AI products
              <br />
              that scale
            </motion.h1>

            <motion.div {...fade(0.32)} className="relative flex items-center gap-5 mt-8">
              <button onClick={() => goto("#contact")}
                className="btn-dark inline-flex items-center gap-2 px-5 py-3 rounded-full text-sm font-semibold">
                Start a project
                <ArrowUpRight size={15} />
              </button>
              <button onClick={() => goto("#services")}
                className="text-sm font-medium text-ink-500 hover:text-ink transition-colors duration-200">
                View services
              </button>
            </motion.div>
          </div>
        </div>

        {/* Bottom meta row */}
        <motion.div {...fade(0.5)}
          className="flex items-end justify-between mt-12 pt-6 border-t hairline">
          <div>
            <div className="eyebrow mb-1">Est.</div>
            <div className="text-2xl font-bold text-ink">2018</div>
          </div>
          <div className="text-right">
            <div className="text-xs font-medium text-ink-500">IT Services Company</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
